import { Button, DialogActions, DialogContent, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React, { Fragment, useState } from "react";
import { transferProviderStatus } from "src/constant";
import useAppGlobal from "src/context/useAppGlobal";
import useTPCreate from "src/hooks/setting/transportation-provider/useTPCreate";
import useTPUpdate from "src/hooks/setting/transportation-provider/useTPUpdate";

export default function TPCreateDialog({ item }) {
  const { closeDialog } = useAppGlobal();
  const { trigger: createTP } = useTPCreate();
  const { trigger: updateTP } = useTPUpdate(item?._id);
  const [tpDetail, setTPDetail] = useState({ type: transferProviderStatus.other });

  const handleCreateTP = async () => {
    let res;
    if (!item) {
      res = await createTP({
        body: tpDetail,
      });
    } else {
      res = await updateTP({
        body: {
          code: tpDetail?.code,
          type: tpDetail?.type,
          name: tpDetail?.name,
        },
      });
    }

    if (res?.success) {
      closeDialog();
      return enqueueSnackbar("Thành công", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message ?? "Có lỗi xảy ra", { variant: "error" });
    }
  };

  return (
    <Fragment>
      <DialogContent>
        <Grid container>
          <Grid
            item
            xs={12}
          >
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue={item?.type ?? transferProviderStatus.other}
                name="radio-buttons-group"
                sx={{ display: "flex", flexDirection: "row" }}
                onChange={(e) => setTPDetail({ ...tpDetail, type: e?.target?.value })}
              >
                <FormControlLabel
                  value={transferProviderStatus.internal}
                  control={<Radio />}
                  label="Nội bộ"
                />
                <FormControlLabel
                  value={transferProviderStatus.other}
                  control={<Radio />}
                  label="Khác"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid
            xs={12}
            item
            mt="12px"
          >
            <TextField
              defaultValue={item?.name}
              fullWidth
              label="Tên đơn vị vận chuyển"
              placeholder="Tên đơn vị vận chuyển"
              onChange={(e) => setTPDetail({ ...tpDetail, name: e?.target?.value })}
            />
          </Grid>
          <Grid
            xs={12}
            item
            mt="24px"
          >
            <TextField
              defaultValue={item?.code}
              fullWidth
              label="Mã đơn vị vận chuyển"
              placeholder="Mã đơn vị vận chuyển"
              onChange={(e) => setTPDetail({ ...tpDetail, code: e?.target?.value })}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: "0 24px 24px" }}>
        <Button
          fullWidth
          onClick={handleCreateTP}
          variant="contained"
        >
          Xác nhận
        </Button>
      </DialogActions>
    </Fragment>
  );
}
